import { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Main from '../../../component/Main.jsx';
import Loading from '../../../component/common/loading/Loading.jsx';
import ExcelDownload from '../../../component/common/button/ExcelDownload.jsx';
import CommonSelect from './CommonSelect09.jsx';
import Pagination from '../../../component/common/dataGrid/Pagination.jsx';
import '../../../css/data-grid.css';

import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import * as Icons from '../../../images/icons/icons_component.js';
import * as Theme from '../../../images/icons/icons_theme';
import { useExcelDownloadHook } from '../../common/excel/useExcelDownloadHook.js';
import useExcelConfirmYn from '../../common/excel/useExcelConfirmYn.js';
import ExcelDownloadReason_layer from '../../../component/common/modal/ExcelDownloadReason_layer.jsx';

export default function BdTrmsHumanResource() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = `${today.getMonth() + 1}`.padStart(2, '0');

    const [searchParams, setSearchParams] = useState(() => {
        const initialGubun = 'N';
        return {
            searchCheck2: currentMonth,
            searchYear: currentYear,
            searchGubun: initialGubun,
            searchEmog: '',
            searchType: '',
            searchFromdate: initialGubun === 'N' ? '' : '01',
            temp: '01',
        };
    });

    const [dataList, setDataList] = useState([]);
    const [clone, setClone] = useState([]);
    const [list, setList] = useState([]);
    const [checkItems, setCheckItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searched, setSearched] = useState(false);
    const [all, setAll] = useState([]);
    const [desc, setDesc] = useState('');

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0,
    });

    const popupPropsInfo = {
        localStorageName: "tableData",
        popupAddress: "/nedis/trmsInfo/trms_humanResource_popup.do",
    };

    const DATA_HEAD = [
        ['의료기관명', '전문과목', '외상센터 근무 시작일', '외상센터 근무 종료일', '전담여부', '전담여부', '인건비', '인건비', '국비', '국비', '전담전문의 근무시작일', '전담전문의 근무종료일', '종료여부', '종료사유', '국비지급 시작일자', '국비지급 종료일자', '전공의 보조인력', '외상수련기관 인력현황', '비고'],
        ['의료기관명', '전문과목', '외상센터 근무 시작일', '외상센터 근무 종료일', '전담', '지원', '국비', '자비', '당직비', 'oncall비', '전담전문의 근무시작일', '전담전문의 근무종료일', '종료여부', '종료사유', '국비지급 시작일자', '국비지급 종료일자', '전공의 보조인력', '외상수련기관 인력현황', '비고'],
    ];

    const DATA_COLUMN = [
        'EMOGDESC',
        'CLNIC_SBJECT_CD',
        'BEGIN_DE',
        'END_DE',
        'ECSHG_AT',
        'ECSHG_NOT_AT',
        'LBCST_NXNDR_AT',
        'LBCST_OXPS_AT',
        'NXNDR_BNDT_AT',
        'NXNDR_CALL_AT',
        'ECSHG_SPCLST_WKBEGIN_DE',
        'ECSHG_SPCLST_WKEND_DE',
        'WKEND_YN',
        'WKEND_REASON',
        'NXNDR_BEGIN_DE',
        'NXNDR_END_DE',
        'ARTR_ASSTN_HNF',
        'OES_HUMAN_RSRC_INFO',
        'ETC_RM',
    ];

    const EXCEL_COLUMN = [
        'EMOGDESC',
        'CLNIC_SBJECT_NM',
        'BEGIN_DE',
        'END_DE',
        'ECSHG_AT',
        'ECSHG_NOT_AT',
        'LBCST_NXNDR_AT',
        'LBCST_OXPS_AT',
        'NXNDR_BNDT_AT',
        'NXNDR_CALL_AT',
        'ECSHG_SPCLST_WKBEGIN_DE',
        'ECSHG_SPCLST_WKEND_DE',
        'WKEND_YN',
        'WKEND_REASON',
        'NXNDR_BEGIN_DE',
        'NXNDR_END_DE',
        'ARTR_ASSTN_HNF',
        'OES_HUMAN_RSRC_INFO',
        'ETC_RM',
    ];

    const API_URL = '/trmsapi/obthrc/get_org_detail_tab_resource_list.do';
    const API_URL_ALL = '/trmsapi/obthrc/get_org_detail_tab_resource_list_all.do';
    const CNT_API_URL = '/trmsapi/obthrc/get_org_detail_tab_resource_cnt.do';
    const EXCEL_FILE_NAME = `${desc || '전체'}_전문의 인력현황`;

    const COLUMN_OPTIONS = {
        WKEND_YN: [
            { value: '', label: '' },
            { value: '1', label: '전담전문의로 근무중인 경우' },
            { value: '2', label: '전담전문의로 근무하지 않는 경우' },
        ],
        WKEND_REASON: [
            { value: '', label: '' },
            { value: '1', label: '본원내 이동' },
            { value: '2', label: '타 권역외상센터로 이동' },
            { value: '3', label: '기타(개인사정 등)' },
        ],
        OES_HUMAN_RSRC_INFO: [
            { value: '', label: '' },
            { value: '1', label: '외상수련전임의' },
            { value: '2', label: '외상지도전문의' },
        ],
        DEFAULT_YN: [
            { value: '', label: '' },
            { value: 'Y', label: 'Y' },
        ],
    };

    const singleHeader = !Array.isArray(DATA_HEAD[0]);
    const headerRows = singleHeader ? [DATA_HEAD] : DATA_HEAD;
    const headerRowCount = headerRows.length;
    const colCount = headerRows[0].length;
    const skip = Array.from({ length: headerRowCount }, () => Array(colCount).fill(false));

    const getHeaderSpans = (r, c) => {
        if (skip[r][c]) return null;
        const value = headerRows[r][c];
        let rowspan = 1;
        let colspan = 1;

        // horizontal
        for (let i = c + 1; i < colCount; i++) {
            if (headerRows[r][i] === value) {
                colspan++;
                skip[r][i] = true;
            } else break;
        }

        // vertical
        if (!singleHeader) {
            for (let i = r + 1; i < headerRowCount; i++) {
                let same = true;
                for (let j = 0; j < colspan; j++) {
                    if (headerRows[i][c + j] !== value) {
                        same = false;
                        break;
                    }
                }
                if (same) {
                    for (let j = 0; j < colspan; j++) skip[i][c + j] = true;
                    rowspan++;
                } else break;
            }
        }

        return { rowspan, colspan, value };
    };

    const computeRowSpans = useCallback((list) => {
        const mergeKey = 'EMOGDESC';
        const spans = list.map(() => ({}));

        let prev = null;
        let start = 0;
        let cnt = 1;

        list.forEach((row, idx) => {
            const cur = row[mergeKey];
            if (cur === prev) {
                spans[start][mergeKey] += 1;
                spans[idx][mergeKey] = 0;
                cnt += 1;
            } else {
                spans[idx][mergeKey] = 1;
                start = idx;
                cnt = 1;
                prev = cur;
            }
        });

        list.forEach((_, i) => {
            DATA_COLUMN.forEach((k) => {
                if (!(k in spans[i])) spans[i][k] = 1;
            });
        });
        return spans;
    }, []);

    const rowSpans = useMemo(() => computeRowSpans(dataList), [dataList, computeRowSpans]);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const { currentPage, itemsPerPage } = pageInfo;
            const params = { ...searchParams, pageNum: currentPage, displayRowsize: itemsPerPage };
            const { data } = await axios.get(API_URL, { params });
            setDataList(data);
            setClone(data);
            if (CNT_API_URL === '') {
                setPageInfo(prev => ({
                    ...prev,
                    totalItems: data.length
                }));
            } else {
                fetchDataCnt();
            }
            setSearched(true);
        } catch (err) {
            console.error('데이터 로딩 오류:', err);
        } finally {
            setLoading(false);
        }
    }, [searchParams, pageInfo]);

    const callList = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/selectResourceInfoSubjList.do',
                { params: { subType: "etc" } }
            );
            setList(response.data);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    const fetchAllData = async () => {
        try {
            const response = await axios.get(API_URL_ALL,
                { params: searchParams }
            );
            setAll(response.data);
        } catch (error) {
            console.error(error);
        }
    }

    const fetchDataCnt = async () => {
        try {
            const response = await axios.get(CNT_API_URL,
                { params: searchParams }
            );
            setPageInfo(prev => ({
                ...prev,
                totalItems: response.data
            }));
        } catch (error) {
            console.error('데이터 카운터 중 오류 발생:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, type, value, checked } = e.target;
        if (name === 'searchGubun') {
            const gubun = checked ? 'Y' : 'N';
            setSearchParams(prev => ({
                ...prev,
                searchGubun: gubun,
                searchFromdate: prev.temp,
                temp: gubun === 'N' ? prev.searchFromdate : '',
            }));
            return;
        }
        setSearchParams(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleAllCheck = (checked) => setCheckItems(checked ? [...clone] : []);

    const handleSingleCheck = (checked, item) => {
        const originalItem = clone.find((row) => row.SEQ === item.SEQ);
        if (!originalItem) return;

        setCheckItems((prev) =>
            checked
                ? [...prev, originalItem]
                : prev.filter((i) => i.SEQ !== item.SEQ)
        );
    };

    const handleCellChange = (rowIdx, colKey, value) => {
        setDataList((prev) => {
            const next = [...prev];
            const currentRow = { ...next[rowIdx] };
            if (currentRow[colKey] === value) return prev;

            const newState =
                currentRow.stateRows === "inserted" ? "inserted" : "updated";

            const exclusivePairs = [
                ["ECSHG_AT", "ECSHG_NOT_AT"],
                ["LBCST_NXNDR_AT", "LBCST_OXPS_AT"],
            ];
            exclusivePairs.forEach(([a, b]) => {
                if (colKey === a) {
                    currentRow[b] = value === "Y" ? "" : "";
                } else if (colKey === b) {
                    currentRow[a] = value === "Y" ? "" : "";
                }
            });
            currentRow[colKey] = value;
            currentRow.stateRows = newState;
            next[rowIdx] = currentRow;
            return next;
        });
    };

    const convertUpdatedRowsToJson = (updateRows) => {
        const jsonArray = updateRows.map((row) => {
            const {
                CLNIC_SBJECT_CD,
                EMOGCODE,
                DETAIL_SN,
                NM,
                LCNS_NO,
                INHBTNT_REG_NO,
                SPCLST_QUALF_NO,
                CRDT_SPCLST_QUALF_NO,
                BEGIN_DE,
                END_DE,
                ECSHG_AT,
                LBCST_NXNDR_AT,
                LBCST_OXPS_AT,
                NXNDR_BNDT_AT,
                NXNDR_CALL_AT,
                NXNDR_BEGIN_DE,
                NXNDR_END_DE,
                ARTR_ASSTN_HNF,
                ETC_RM,
                ECSHG_SPCLST_WKBEGIN_DE,
                ECSHG_SPCLST_WKEND_DE,
                WKEND_YN,
                WKEND_REASON,
                OES_HUMAN_RSRC_INFO
            } = row;

            return {
                clnicSbjectCd: CLNIC_SBJECT_CD || '',
                emogCode: EMOGCODE || '',
                nm: NM || '',
                detailSn: DETAIL_SN || '',
                lcnsNo: LCNS_NO || '',
                inhbtntRegNo: INHBTNT_REG_NO || '',
                spclstQualfNo: SPCLST_QUALF_NO || '',
                crdtSpclstQualfNo: CRDT_SPCLST_QUALF_NO || '',
                beginDe: BEGIN_DE || '',
                endDe: END_DE || '',
                ecshgAt: ECSHG_AT || '',
                lbcstNxndrAt: LBCST_NXNDR_AT || '',
                lbcstOxpsAt: LBCST_OXPS_AT || '',
                nxndrBndtAt: NXNDR_BNDT_AT || '',
                nxndrCallAt: NXNDR_CALL_AT || '',
                nxndrBeginDe: NXNDR_BEGIN_DE || '',
                nxndrEndDe: NXNDR_END_DE || '',
                artrAsstnHnf: ARTR_ASSTN_HNF || '',
                etcRm: ETC_RM || '',
                ecshgSpclstWkBeginDe: ECSHG_SPCLST_WKBEGIN_DE || '',
                ecshgSpclstWkEndDe: ECSHG_SPCLST_WKEND_DE || '',
                wkEndYN: WKEND_YN || '',
                wkEndReason: WKEND_REASON || '',
                oesHumanRsrcinfo: OES_HUMAN_RSRC_INFO || '',
                delFlag: '',
            };
        });
        return jsonArray;
    };

    const convertDeletedRowsToJson = (checkRows) => {
        const deleted = checkRows.map((row) => ({
            clnicSbjectCd: '',
            emogCode: row.EMOGCODE || '',
            nm: '',
            detailSn: row.DETAIL_SN || '',
            lcnsNo: '',
            inhbtntRegNo: '',
            spclstQualfNo: '',
            crdtSpclstQualfNo: '',
            beginDe: '',
            endDe: '',
            ecshgAt: '',
            lbcstNxndrAt: '',
            lbcstOxpsAt: '',
            nxndrBndtAt: '',
            nxndrCallAt: '',
            nxndrBeginDe: '',
            nxndrEndDe: '',
            artrAsstnHnf: '',
            etcRm: '',
            ecshgSpclstWkBeginDe: '',
            ecshgSpclstWkEndDe: '',
            wkEndYN: '',
            wkEndReason: '',
            oesHumanRsrcinfo: '',
            delFlag: 'Y'
        }));
        return deleted;
    };

    const handlePageChange = (page) => {
        if (page !== pageInfo.currentPage) setPageInfo((prev) => ({ ...prev, currentPage: page }));
    };

    const onHandlePerPage = (e) => {
        setPageInfo(prev => ({
            ...prev,
            itemsPerPage: parseInt(e.target.value)
        }));
    };

    const search = () => {
        setPageInfo(prev => ({
            ...prev,
            currentPage: 1,
        }));
        fetchData();
        setCheckItems([]);
    };

    const save = async () => {
        const updatedRows = dataList.filter(row => row.stateRows === 'updated');
        const jsonArray = convertUpdatedRowsToJson(updatedRows);
        const deleted = convertDeletedRowsToJson(checkItems);

        const combined = [...jsonArray, ...deleted];
        const payload = new URLSearchParams({
            emogcode: searchParams.searchEmog,
            hnfData: JSON.stringify(combined),
            userId: localStorage.getItem("id"),
        });

        try {
            const response = await fetch('/trmsapi/obthrc/update_hnf_data_list.do', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: payload,
            });

            if (!response.ok) {
                throw new Error(`서버 오류: ${response.status}`);
            }
            alert('저장이 완료되었습니다.');
        } catch (error) {
            console.error('저장 중 오류 발생:', error);
            alert('저장에 실패했습니다. 관리자에게 문의하세요.');
        }
    };

    const download = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/download.do', {
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;

            const disposition = response.headers['content-disposition'];
            const match = disposition && disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            const filename = match ? decodeURIComponent(match[1].replace(/['"]/g, '')) : 'template.xlsx';

            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error('다운로드 실패:', error);
        }
    };

    const upload = () => {
        if (searchParams.searchEmog === '') {
            alert("기관을 선택해주세요.");
            return false;
        } else {
            const senData = {
                tableOwner: 'TRUMAUSER',
                tableName: 'TRAUMA_HNF_T',
                head: [['전문과목', '성명', '의사면허번호', '주민등록번호', '전문의 자격번호', '외사외과 세부전문의 자격번호', '외상센터 근무시작일', '외상센터 근무종료일', '전담여부', '인건비', '인건비', '국비', '국비', '전담전문의 근무시작일', '전담전문의 근무종료일', '종료여부', '종료사유', '국비지급 시작일자', '국비지급 종료일자', '전공의 보조인력', '외상수련기관 인력현황', '비고'],
                ['전문과목', '성명', '의사면허번호', '주민등록번호', '전문의 자격번호', '외사외과 세부전문의 자격번호', '외상센터 근무시작일', '외상센터 근무종료일', '전담여부', '국비', '자비', '당직비', 'oncall비', '전담전문의 근무시작일', '전담전문의 근무종료일', '종료여부', '종료사유', '국비지급 시작일자', '국비지급 종료일자', '전공의 보조인력', '외상수련기관 인력현황', '비고']],
                emogCode: searchParams.searchEmog,
            }

            let popup = null;

            localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(senData));
            popup = window.open(popupPropsInfo.popupAddress, "팝업", "scrollbars=1, resizable=0, width=1200, height=850, top=30, left=30");
        }
    };

    const renderCell = (row, rowIdx, colKey) => {
        const span = rowSpans[rowIdx][colKey];
        if (span === 0) return null;
        const value = row[colKey] ?? '';

        if (['BEGIN_DE',
            'END_DE',
            'ECSHG_SPCLST_WKBEGIN_DE',
            'ECSHG_SPCLST_WKEND_DE',
            'NXNDR_BEGIN_DE',
            'NXNDR_END_DE'].includes(colKey)) {
            return (
                <td key={colKey} rowSpan={span} className='text-center'>
                    <input type="date" value={value} onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)} />
                </td>
            );
        };

        if (["ECSHG_AT",
            "ECSHG_NOT_AT",
            "LBCST_NXNDR_AT",
            "LBCST_OXPS_AT",
            "NXNDR_BNDT_AT",
            "NXNDR_CALL_AT",
            "ARTR_ASSTN_HNF"].includes(colKey)) {
            const isChecked = value === "Y";
            return (
                <td key={colKey} rowSpan={span}>
                    <div className='flex justify-center cursor-pointer'>
                        {isChecked ? (
                            <Icons.TrIcoChecked onClick={() => handleCellChange(rowIdx, colKey, "")} />
                        ) : (
                            <Icons.TrIcoUnchecked onClick={() => handleCellChange(rowIdx, colKey, "Y")} />
                        )}
                    </div>
                </td>
            );
        };

        if (['EMOGDESC',
            'ETC_RM'].includes(colKey)) {
            return (
                <td key={colKey} rowSpan={span}>
                    <input
                        type="text"
                        value={value}
                        className='h-7 outline-none bg-transparent truncate'
                        onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)}
                    />
                </td>
            );
        };

        if (['CLNIC_SBJECT_CD'].includes(colKey)) {
            return (
                <td key={colKey} rowSpan={span}>
                    <select value={value} onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)}>
                        {list.map((o) => (
                            <option key={o.CD} value={o.CD}>
                                {o.CD_NM}
                            </option>
                        ))}
                        <option value="PM">외상프로그램매니저</option>
                        <option value="CD">외상코디네이터</option>
                    </select>
                </td>
            )
        };

        const opts = COLUMN_OPTIONS[colKey] || COLUMN_OPTIONS.DEFAULT_YN;
        return (
            <td key={colKey} rowSpan={span}>
                <select value={value} onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)}>
                    {opts.map((o) => (
                        <option key={o.value} value={o.value}>
                            {o.label}
                        </option>
                    ))}
                </select>
            </td>
        );
    };

    useEffect(() => {
        search();
        callList();
        fetchAllData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [pageInfo.currentPage]);

    const perPageOptions = Array.from({ length: 10 }, (_, i) => {
        const perPage = (i + 1) * 10;
        return (
            <option key={perPage} value={perPage}>
                -- {perPage}건 씩 조회 --
            </option>
        );
    });

    const { fontColor, lightBackColor, borderColorGray } = useDynamicStyle();

    const confirmYn = useExcelConfirmYn();
    const path = decodeURIComponent(useLocation().pathname);
    const { isModalOpen, isDown, updateParams, openConfModal, closeModal, handleUpdateInputChange, setIsDown } = useExcelDownloadHook();

    return (
        <Main>
            <ExcelDownloadReason_layer
                isModalOpen={isModalOpen}
                closeModal={closeModal}
                updateParams={updateParams}
                handleUpdateInputChange={handleUpdateInputChange}
                searchParams={searchParams}
                route={path}
                excelFileName={`${EXCEL_FILE_NAME}.xlsx`}
                setIsDown={setIsDown}
            />
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="29%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <CommonSelect searchParams={searchParams} handleInputChange={handleInputChange} setDesc={setDesc} />
                        <tr>
                            <th>엑셀 업로드</th>
                            <td className='flex'>
                                <button onClick={upload} className='search_btn bg_tr_primary'><Icons.Upload16w />엑셀업로드</button>
                                <button onClick={download} className='excel_form_down'><Theme.Download16 className='co_black' />양식다운로드</button>
                            </td>
                            <th>전문과목</th>
                            <td>
                                <select
                                    id='searchType'
                                    name='searchType'
                                    value={searchParams.searchType}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    {list.map((o) => (
                                        <option key={o.CD} value={o.CD}>
                                            {o.CD_NM}
                                        </option>
                                    ))}
                                    <option value="PM">외상프로그램매니저</option>
                                    <option value="CD">외상코디네이터</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="search_btn_wrapper">
                <span className='total_items'>전체&nbsp;<strong className={fontColor}>{pageInfo.totalItems}</strong>건</span>
                <div className='btn_container'>
                    <select
                        name="itemsPerPage"
                        value={pageInfo.itemsPerPage}
                        className='page_select'
                        onChange={onHandlePerPage}
                    >
                        {perPageOptions}
                    </select>
                    <button onClick={search} disabled={loading} className='search_btn bg_tr_primary'><Icons.Search16w />조회</button>
                    <button onClick={save} disabled={loading} className='search_btn bg_co_black'><Icons.Save16w />저장</button>
                    <ExcelDownload
                        excelHead={DATA_HEAD}
                        excelData={searchParams.searchEmog ? clone : all}
                        searched={searched}
                        dataCode={EXCEL_COLUMN}
                        excelFileName={EXCEL_FILE_NAME}
                        confirmYn={confirmYn}
                        openConfModal={openConfModal}
                        isDown={isDown}
                    />
                </div>
            </div>

            {loading ? <Loading />
                : (
                    <div className='data_grid_container'>
                        <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                        <div className={`data_list_table ${searched ? 'grid-animation' : ''}`}>
                            <table style={{ width: '2188px' }}>
                                <colgroup>
                                </colgroup>
                                <thead className='middle'>
                                    {headerRows.map((row, rIdx) => (
                                        <tr key={rIdx}>
                                            {rIdx === 0 && (
                                                <th rowSpan={headerRowCount}>
                                                    <div>
                                                        {dataList.length > 0 && checkItems.length === dataList.length ?
                                                            <Icons.CheckOk className='cursor-pointer' onClick={() => handleAllCheck(false)} />
                                                            :
                                                            <Icons.CheckNon className='cursor-pointer' onClick={() => handleAllCheck(true)} />
                                                        }
                                                    </div>
                                                </th>
                                            )}
                                            {row.map((col, cIdx) => {
                                                const span = getHeaderSpans(rIdx, cIdx);
                                                if (!span) return null;
                                                const { rowspan, colspan, value } = span;
                                                return (
                                                    <th key={`${rIdx}-${cIdx}`} rowSpan={rowspan} colSpan={colspan}>
                                                        {value}
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </thead>
                                <tbody>
                                    {dataList.map((row, rowIdx) => {
                                        const isChecked = checkItems.some((i) => i.SEQ === row.SEQ);
                                        const oe = rowIdx % 2 === 0 ? lightBackColor : '';
                                        return (
                                            <tr key={row.SEQ || rowIdx} className={oe}>
                                                <td>
                                                    <div className='flex justify-center'>
                                                        {isChecked ?
                                                            <Icons.CheckOk className='cursor-pointer' onClick={() => handleSingleCheck(false, row)} />
                                                            :
                                                            <Icons.CheckNon className='cursor-pointer' onClick={() => handleSingleCheck(true, row)} />
                                                        }
                                                    </div>
                                                </td>
                                                {DATA_COLUMN.map((colKey) => renderCell(row, rowIdx, colKey))}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <hr className='mr-1-1 co_border_gray' />
                        {dataList.length > 0 && pageInfo.paginationTF && (
                            <div>
                                <Pagination paginationInfo={{ ...pageInfo, onPageChange: handlePageChange }} />
                            </div>
                        )}
                    </div>
                )}
        </Main >
    );
}
